import { configuration } from 'src/configuration';

export function checkUrl(url: string | null, isLocal?: boolean): string {
  if (!url) {
    return configuration.appUrl;
  }

  // If using localhost or sending the isLocal variable in dev
  if (
    configuration.medeloopEnvironment === 'local' ||
    (configuration.medeloopEnvironment === 'dev' && isLocal)
  ) {
    if (url.includes('localhost')) {
      return url;
    }

    return configuration.appUrl;
  }

  if (url.includes('.medeloop.ai/')) {
    return url;
  }

  return configuration.appUrl;
}

export function safeRedirect(url: string | null, isLocal?: boolean) {
  const redirectUrl = checkUrl(url || '', isLocal);

  window.location.replace(redirectUrl);
}
